// Auth constants
export const LOGIN_PATH = '/user/login';
export const ACCESS_TOKEN_KEY = 'accessToken';
export const EXPIRES_IN_KEY = 'expiresIn';
export const CURRENT_USER_QUERY_KEY = ['currentUser'] as const;
